import {notice} from "../UI/notice";
import Agent from "../Core/agent";
import {parseHTML} from "../Core/common";
import JsTabs from "js-tabs";

const favorites = new Map(Object.entries(JSON.parse(localStorage.getItem('favorites') || '{}')));
const favoritesLink = document.querySelector('.js_favorites_link');
function setTotalFavorites() {
    let totalCount = 0;
    favorites.forEach(values => {
        totalCount += values.length;
    });
    document.querySelectorAll('.js_total_count_favorites').forEach(item => {
        item.classList.remove('preloader');
        item.innerHTML = totalCount;
    });


    // if(totalCount && favoritesLink){
    //     favoritesLink.classList.add('active');
    // }else if(favoritesLink){
    //     favoritesLink.classList.remove('active');
    // }
}

setTotalFavorites();

const favoritesEvent = (item, id, type) => {
    item.addEventListener('click', () => {
        let items = favorites.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            items.splice(index, 1);
            notice('Удален из избранного');

            document.querySelectorAll(`.js_add_favorites[data-id="${id}"]`).forEach(item => {
                item.classList.remove('active');
                item.title = 'Добавить в избранное';
            });

        } else {
            items.push(id);
            notice('Добавлен в избранное');

            document.querySelectorAll(`.js_add_favorites[data-id="${id}"]`).forEach(item => {
                item.title = 'Удалить из избранного';
                item.classList.add('active');
            });
        }

        favorites.set(type, items);
        setTotalFavorites();
        localStorage.setItem('favorites', JSON.stringify(Object.fromEntries(favorites.entries())));
    });
};

const removeBlock = element => {
    element.remove();
    if (!document.querySelector('.js_load_favorites')) {
        document.querySelector('section.choosing').classList.remove('d-none');
    }
};

const tabInit = item => {
    if (item.querySelector('.compare-tabs')) {
        let block = document.querySelector('.compare-tabs').closest('section');
        document.querySelectorAll('.compare-tabs').forEach(item => {
            const compareTabs = new JsTabs({
                elm: item,
                shouldScrollTabIntoView: false,
            });
            compareTabs.init();
            item.querySelector(".js-tabs__tab").classList.add("active");
            item.querySelector(".js-tabs__content").classList.add("active");

            item.querySelectorAll(".js-tabs__tab").forEach(tab => {
                let article = tab.dataset.article;
                tab.querySelector('.btn-close').addEventListener('click', () => {
                    let currentTabContent = item.querySelector(`.js-tabs__content[data-article="${article}"]`);

                    currentTabContent.querySelectorAll('.js_add_favorites').forEach(btn => {
                        const id = btn.dataset.id;
                        const type = btn.dataset.type;
                        let items = favorites.get(type) || [];
                        let index = items.indexOf(id);
                        if (index >= 0) {
                            items.splice(index, 1);
                            favorites.set(type, items);
                        }
                    });

                    setTotalFavorites();
                    localStorage.setItem('favorites', JSON.stringify(Object.fromEntries(favorites.entries())));

                    if (currentTabContent) {
                        currentTabContent.remove();
                        tab.remove();
                    }

                    let firstTab = item.querySelector(".js-tabs__tab");
                    if (firstTab) {
                        firstTab.classList.add("active");
                        item.querySelector(".js-tabs__content").classList.add("active");
                    } else {
                        removeBlock(block);
                    }
                });
            });
        });
    }
};

const deleteItem = item => {
    const id = item.dataset.id;
    const type = item.dataset.type;
    const tabBlock = item.closest('.compare-tabs');
    const block = item.closest('section');

    item.closest('.js_item').remove();

    let items = favorites.get(type) || [];
    let index = items.indexOf(id);
    if (index >= 0) {
        items.splice(index, 1);
        notice('Удален из избранного');

        favorites.set(type, items);
        setTotalFavorites();
        localStorage.setItem('favorites', JSON.stringify(Object.fromEntries(favorites.entries())));

        if (tabBlock) {
            const currentTab = tabBlock.querySelector('.js-tabs__tab.active');
            let article = currentTab.dataset.article;

            let currentTabContent = tabBlock.querySelector(`.js-tabs__content[data-article="${article}"]`);

            if(!currentTabContent.querySelector('.js_item')){
                currentTabContent.remove();
                currentTab.remove();

                let firstTab = tabBlock.querySelector(".js-tabs__tab");
                if (firstTab) {
                    firstTab.classList.add("active");
                    tabBlock.querySelector(".js-tabs__content").classList.add("active");
                } else {
                    removeBlock(block);
                }
            }
        }else{
            if(!block.querySelector('.js_item')){
                removeBlock(block);
            }
        }
    }
};

export const favoritesInitItem = item => {
    if (!item.classList.contains('js_favorites_initialized')) {
        item.classList.add('js_favorites_initialized');

        const id = item.dataset.id;
        const type = item.dataset.type;

        let items = favorites.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            item.classList.add('active');
            item.title = 'Удалить из избранного';
        }

        favoritesEvent(item, id, type);
    }
};


export const favoritesInit = (selector, events) => {
    document.querySelectorAll(selector).forEach(item => favoritesInitItem(item));

    document.querySelectorAll('.js_load_favorites').forEach(item => {
        let type = item.dataset.type;
        let items = favorites.get(type);
        if (items && items.length) {
            Agent.post(`/favorites/${type}.html`, JSON.stringify(items), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(e => e.json())
                .then(e => {
                    item.classList.remove('preloader');
                    if (e.success) {
                        item.append(parseHTML(e.data));
                        events.dispatch('filter.search');

                        item.querySelectorAll('.js_delete_item').forEach(btn => btn.addEventListener('click', deleteItem.bind(null, btn)));
                    } else {
                        removeBlock(item.closest('section'));
                    }
                })
                .catch(e => console.log(e));
        } else {
            removeBlock(item.closest('section'));
        }

        if (!document.querySelector('.js_load_favorites')) {
            document.querySelector('section.choosing').classList.remove('d-none');
        }
    });
};